import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { CheckboxWithLink } from '@mopla/ui';
import { useI18nLanguage } from '@mopla/utils';

export const linkByLang: Record<string, string> = {
	de: 'https://www.mopla.solutions/de/agb',
	en: 'https://www.mopla.solutions/de/agb',
	fr: 'https://www.mopla.solutions/de/agb',
	pl_PL: 'https://www.mopla.solutions/de/agb',
	tr: 'https://www.mopla.solutions/de/agb',
	cs: 'https://www.mopla.solutions/de/agb',
	uk_UA: 'https://www.mopla.solutions/de/agb',
};

interface IProps {
	checked: boolean;
	toggleCheckbox: VoidFunction;
}

interface IWithAGBLinkProps {
	render: (link: string) => ReactNode;
}

export const WithAGBLink: FC<IWithAGBLinkProps> = ({ render }) => {
	const lng = useI18nLanguage();

	return <>{render(linkByLang[lng])}</>;
};

export const TermsAndConditions: FC<IProps> = (props) => {
	const { checked, toggleCheckbox } = props;
	const { t } = useTranslation(['registration']);

	return (
		<WithAGBLink
			render={(link) => (
				<CheckboxWithLink
					testId="terms-of-use"
					url={link}
					linkText={
						t('text.check_terms_and_policy', {
							value: t('text.terms_of_use'),
						}) + '*'
					}
					checked={checked}
					toggleCheckbox={toggleCheckbox}
				/>
			)}
		/>
	);
};
